<template>
    <transition name="notifications">
        <div v-if="isNotificationsOpen" class="overlay" @click="close">
            <aside @click.stop class="notifications">
                <header class="notifications__header">
                    <h3 class="notifications__title">Notifications</h3>
                    <a v-if="hasNotifications" href="#" @click.prevent="clear()" class="lc-clear notifications__action">Mark all as read</a>
                    <button @click="close" class="icon-button notifications__close">
                        <icon type="close" color="bluegray" size="18" />
                    </button>
                </header>

                <section v-if="hasNotifications" class="notifications__list">
                    <template v-for="block in notificationBlocks">
                        <div :key="block.key" class="notifications__group">
                            <p class="notifications__date">{{ block.key | formattedDate }}</p>
                            <template v-for="(chunk, index) in block.chunks">
                                <notification v-if="chunk.job === null" :notification="chunk.notifications[0]" :key="index" />
                                <accordion v-else :job="chunk.job" :notifications="chunk.notifications" :key="index" />
                            </template>
                        </div>
                    </template>
                </section>

                <empty v-else type="cuppa" title="You're all caught up!" subtitle="Check back later for new requests" />
            </aside>
        </div>
    </transition>
</template>

<script>
/* global Echo, app */
import Push from 'push.js'
import Strip from '../../helpers/strip'
import { mapState, mapMutations } from 'vuex'
import Empty from '../Global/Empty'
import Icon from '../Global/Icon'
import Accordion from './Accordion'
import Notification from './Notification'
import { CLOSE_NOTIFICATIONS } from '../../stores/global/mutations'
import NotificationsPresenter from '../../helpers/NotificationsPresenter'

export default {
    name: 'Notifications',

    created () {
        this.$store.dispatch('notifications/getNotifications')

        Echo.private(`${app.currentTenant.id}_user_${app.currentUser.id}`)
            .notification((notification) => {
                this.$store.commit('notifications/addNotification', notification)

                Push.create(notification.job ? notification.job.title : notification.channel.name, {
                    body: Strip(notification.message),
                    icon: app.notificationImage
                }).catch(() => {})
            })
    },

    methods: {
        ...mapMutations({
            close: CLOSE_NOTIFICATIONS
        }),

        clear () {
            this.$store.dispatch('notifications/clearNotifications')
        }
    },

    computed: {
        ...mapState(['isNotificationsOpen']),
        ...mapState('notifications', ['notifications']),

        notificationBlocks () {
            let presenter = new NotificationsPresenter()

            return presenter.present(this.notifications)
        },

        hasNotifications () {
            return this.notifications.length > 0
        }
    },

    components: {
        Accordion,
        Notification,
        Empty,
        Icon
    }
}
</script>
